import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

const ExportButtons = ({ onDownload, title }) => {
    return (
        <div className="flex justify-between items-center gap-2 mb-4 flex-wrap">
            <h2 className="text-xl font-bold">{title}</h2>
            <div className="flex justify-end items-center gap-2 flex-wrap">
                <button
                    onClick={() => onDownload("pdf")}
                    className="flex items-center gap-1 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded text-sm"
                >
                    <ArrowDownTrayIcon className="w-4 h-4" />
                    Export PDF
                </button>
                <button
                    onClick={() => onDownload("excel")}
                    className="flex items-center gap-1 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm"
                >
                    <ArrowDownTrayIcon className="w-4 h-4" />
                    Export Excel
                </button>
                <button
                    onClick={() => onDownload("print")}
                    className="flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
                >
                    <ArrowDownTrayIcon className="w-4 h-4" />
                    Print
                </button>
            </div>
        </div>
    );
};

export default ExportButtons;